/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

 bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      setTimeout(enforceCartQuantityLimits, 50);
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      setTimeout(enforceCartQuantityLimits, 30);
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  } 

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);

async function enforceCartQuantityLimits() {
  const cartContainer = document.querySelector('cart-drawer') || document.querySelector('cart-form');
  if (!cartContainer) return;

  try {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    const productTotals = {};
    cart.items?.forEach(item => {
      const pid = item.product_id;
      if (!productTotals[pid]) {
        productTotals[pid] = { total: 0, variantIds: new Set() };
      }
      productTotals[pid].total += item.quantity;
      productTotals[pid].variantIds.add(item.variant_id);
    });

    cartContainer.querySelectorAll('[data-product-id][data-quantity-limit]').forEach(row => {
      const productId = parseInt(row.dataset.productId);
      const limit = parseInt(row.dataset.quantityLimit);
      const productData = productTotals[productId];

      if (!productData || !limit || limit >= 999) return;

      const isAtLimit = productData.total >= limit;

      const incrementBtn = row.querySelector('a.quantity-up');
      const decrementBtn = row.querySelector('a.quantity-down'); 
      const qtyInput = row.querySelector('input.cart-item__quantity-input, input[name="updates[]"]');

      if (incrementBtn) {
        incrementBtn.disabled = isAtLimit;
        incrementBtn.setAttribute('aria-disabled', isAtLimit ? 'true' : 'false');
        incrementBtn.classList.toggle('is-disabled', isAtLimit);
        
        // Tooltip 
        if (isAtLimit) {
          incrementBtn.title = `Maximum ${limit} ${limit === 1 ? 'item' : 'items'} allowed per order`;
        } else {
          incrementBtn.removeAttribute('title');
        }
      }

    
    });

  } catch (e) {
    console.error('enforceCartQuantityLimits error:', e);
  }
}

document.addEventListener('on:cart:after-merge', () => {
  setTimeout(enforceCartQuantityLimits, 30);
});

document.addEventListener('on:cart-drawer:before-open', () => {
  setTimeout(enforceCartQuantityLimits, 50);
});

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('cart-drawer, cart-form')) {
    setTimeout(enforceCartQuantityLimits, 100);
  }
});

document.addEventListener('change', (e) => {
  if (e.target.matches('cart-drawer input[name="updates[]"], cart-drawer input[name="quantity"], cart-form input[name="updates[]"], cart-form input[name="quantity"]')) {
    setTimeout(enforceCartQuantityLimits, 30);
  }
});

document.addEventListener('click', (e) => {
  if (e.target.closest('[data-action="increment"], [data-action="decrement"], .qty-btn-plus, .qty-btn-minus, .quantity__button')) {
    setTimeout(enforceCartQuantityLimits, 30);
  }
});



/* global SideDrawer */
const EXPEDITED_VARIANT_ID = 45043940851765;
let expeditedLock = false;

/**
 * Refresh cart UI sections
 */
async function refreshCartSections() {
  const drawer = document.querySelector('cart-drawer');
  const header = document.querySelector('page-header');

  // Refresh header via Sections API
  if (header?.dataset.sectionId) {
    try {
      const sectionId = header.dataset.sectionId;
      const res = await fetch(`/cart?sections=${sectionId}`);
      const data = await res.json();
      const html = data[sectionId];
      if (html && typeof header.updateFromCartChange === 'function') {
        header.updateFromCartChange(html);
      }
    } catch (e) {
      console.error('Header update error:', e);
    }
  }

  // Refresh drawer via native event
  if (drawer) {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
  }
}

/**
 * Add expedited processing product to cart
 */
async function addExpedited() {
  if (expeditedLock) return;
  expeditedLock = true;

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: EXPEDITED_VARIANT_ID, quantity: 1 })
    });
    await refreshCartSections();
  } catch (e) {
    console.error('addExpedited error:', e);
  } finally {
    expeditedLock = false;
  }
}

/**
 * Remove expedited processing product from cart
 */
async function removeExpedited() {
  if (expeditedLock) return;
  expeditedLock = true;

  try {
    // Fetch current cart to find the line item key
    const cartRes = await fetch('/cart.js');
    const cartData = await cartRes.json();
    
    // Find the line item with matching variant_id
    const lineItem = cartData.items?.find(item => item.variant_id === EXPEDITED_VARIANT_ID);
    
    if (!lineItem) {
      await refreshCartSections();
      return;
    }
    
    // Remove via line item key (required for /cart/change.js)
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineItem.key, quantity: 0 })
    });
    
    await refreshCartSections();
  } catch (e) {
    console.error('removeExpedited error:', e);
  } finally {
    expeditedLock = false;
  }
}

/**
 * Attach change listener to expedited checkbox
 */
function initExpeditedCheckbox() {
  const checkbox = document.querySelector('#expedited-processing-checkbox');
  if (!checkbox || checkbox.dataset.listenerAttached) return;
  
  checkbox.dataset.listenerAttached = 'true';
  checkbox.addEventListener('change', async () => {
    if (checkbox.checked) {
      await addExpedited();
    } else {
      await removeExpedited();
    }
  });
}

// Initialize when drawer opens
document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('cart-drawer')?.addEventListener('on:cart-drawer:before-open', initExpeditedCheckbox);
});

// Re-initialize after cart DOM is merged/refreshed
document.addEventListener('on:cart:after-merge', initExpeditedCheckbox);